import { Component } from "react"

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo)
  }

  handleReload = () => {
    window.location.reload()
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center px-4">
          <div className="max-w-md w-full p-6 bg-red-100 rounded-lg text-center">
            <h2 className="text-lg font-semibold text-rose-700 mb-2">
              Something went wrong
            </h2>
            <p className="text-sm text-rose-700 mb-4">
              An unexpected error occurred while rendering this page.
            </p>
            <button
              className="px-4 py-2 bg-primary text-white rounded text-sm"
              type="button"
              onClick={this.handleReload}
            >
              Reload page
            </button>
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
